function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 475"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1457"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1462"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 474"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 837",
  d: "M8.077 13.942 1.103 7.558l6.964-6.541.773.691-6.219 5.841 6.214 5.694Z",
  fill: "none",
  stroke: "#00a9ff",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1115",
  d: "M16.089 20.956H2.263a1.525 1.525 0 0 1 0-2.961h13.826a1.351 1.351 0 0 0 1.16-1.48v-6.337a1.351 1.351 0 0 0-1.16-1.48H2.744c1.371 1.771 1.362-4.713-.027-2.961h13.372c1.918 0 3.479 1.992 3.479 4.441v6.342c0 2.444-1.561 4.436-3.479 4.436Z",
  fill: "#00a9ff"
}))));

function SvgStakeBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.568,
    height: 20.956,
    viewBox: "0 0 19.568 20.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeBackIcon);
export default __webpack_public_path__ + "static/media/stake-back-icon.da98ebe0.svg";
export { ForwardRef as ReactComponent };